<template>
  <div class="hotleheadmain">
    <div class="hotlehead">
      <div class="hotelname">
        <h1   v-if="getHotelInfo">{{ getHotelInfo.hotelname }} </h1>  
       
        <h3>
          <img :src="require('assets/images/address.png').default" />
          <span v-if="getHotelInfo">{{ getHotelInfo.address }}</span>
        </h3>

        <!-- <h1>{{ gethotename?gethotename:getloaclhotlename }}</h1> -->
      </div>
      <div class="hotelphone" @click="callPhoneNumber">
        <h3 v-if="telphone">{{ telphone }}</h3>
        <p>请拨打订房热线，获取实时最新优惠价格!</p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { setStorage, getStorage } from "@/common/until/until";
export default {
  name: "hotelhead",
  data() {
    return {
      isshow: false,
      hotelnames: null,
    };
  },
  methods: {
    callPhoneNumber() {
      window.location.href = "tel:" + this.telphone;
      this.hotelcatchbdfun(this.telphone);
      // console.log(1);
    },
    hotelcatchbdfun: function (telphone) {
      const url = window.location.href;
      console.log(telphone);
      const hotelname = this.$store.state.hotelinfro.hotelname;
      const address = this.$store.state.hotelinfro.address;
      const zid = this.$route.query.hid;
      let hidp = "";
      let that = this;
      let referrer = document.referrer;
      let ismobiles = "no";
      if ("ontouchstart" in document.documentElement) {
        ismobiles = "1";
      }
      let loa = encodeURIComponent(location.href);
      let hiddenProperty =
        "hidden" in document
          ? "hidden"
          : "webkitHidden" in document
          ? "webkitHidden"
          : "mozHidden" in document
          ? "mozHidden"
          : null;
      if (document[hiddenProperty]) {
        hidp = "ishide";
      } else {
        hidp = "nohide";
      }
      if (hiddenProperty == null) {
        hidp = "nullhide";
      }
      window.dispatchEvent(
        new CustomEvent("jd:getfunc", {
          detail: {
            zq: $,
            param: {
              type: "get",
              url:
                "https://api.tetuijiudian.com/bdfun.php?fun=bdfunpv&zid=" +
                zid +
                "&hidp=" +
                hidp +
                "&loa=" +
                loa +
                "&ismobiles=" +
                ismobiles +
                "&address=" +
                address +
                "&hotelname=" +
                hotelname +
                "&referrer=" +
                referrer +
                "&wap=0" +
                "&clicktel=" +
                telphone,

              dataType: "json",
              success: function (response) {},
              complete: function () {},
              error: function () {},
            },
          },
        })
      );
    },
    getnams() {
      const hotelnamesFromLocalStorage = localStorage.getItem("hotelnameinfo"); // 从 localStorage 中获取值
      let hotelnames = hotelnamesFromLocalStorage
        ? JSON.parse(hotelnamesFromLocalStorage)
        : null;
      return hotelnames;
    },
  },
  computed: {
    ...mapGetters(["getHotelInfo"]),
    telphone() {
      return this.$store.state.hotelphone; // 访问 Vuex Store 中的状态
    },
    gethotename() {
      let hotelnames = this.$store.state.hotelnames; // 尝试从 Vuex Store 中获取值

      return hotelnames; // 返回赋值后的变量
    },
    getloaclhotlename() {
      let hotelnames = this.$store.state.hotelnames; // 尝试从 Vuex Store 中获取值
      return hotelnames; // 返回赋值后的变量
    },
  },
};
</script>

<style lang="less">
.hotlehead {
  display: flex;
  height: 101px;
  background: #fcf9f9;
  border-radius: 3px;
  justify-content: space-between;
  border-bottom: 5px solid #ff5555;
  box-sizing: border-box;
  padding: 10px;
  margin-bottom: 23px;
  .hotelname {
    display: flex;
    justify-content: space-evenly;
    flex-direction: column;
  }
  .hotelname h1 {
    font-size: 30px;
    font-weight: 400;
    color: #150101;
  }
  .hotelname h3 {
    font-size: 12px;
    font-weight: 400;
    color: #555;
    display: flex;
    align-items: center;
    img {
      margin-right: 5px;
    }
  }
  .hotelphone {
    text-align: right;
    display: flex;
    justify-content: space-evenly;
    flex-direction: column;
  }
  .hotelphone p {
    font-size: 14px;
    font-weight: 400;
    color: #888;
  }
  .hotelphone h3 {
    font-size: 36px;
    font-family: Arial;
    font-weight: bold;
    color: #ff5555;
  }
}

@media (min-width: 320px) and (max-width: 780px) {
  .main {
    position: relative;
    z-index: 10;
  }
  .hotlehead {
    height: auto;
    flex-wrap: wrap;
    position: relative;
    background: #11aa66;
    min-height: 80px;
    z-index: 1;
    .hotelname {
      width: 100%;
      color: #fff;
      p {
        color: #fff;
      }
      h1 {
        font-size: 22px;
        line-height: 42px;
        height: 42px;
        color: #fff;
        overflow: hidden;
        width: 85%;
        white-space: nowrap; /* 防止文本换行 */
        overflow: hidden; /* 超出部分隐藏 */
        text-overflow: ellipsis; /* 显示省略号 */
      }
      .hotelshort {
        font-size: 24px;
        text-align: center;
      }
      .hotellong {
        font-size: 16px;
      }
      h3 {
        span {
          color: #fff;
          line-height: 21px;
          height: 21px;
          overflow: hidden;
        }
      }
    }
    .hotelphone {
      display: none;
      width: 70px;
      height: 70px;
      text-align: left;
      position: absolute;
      right: 0;
      top: 5px;
      background: url(~@/assets/images/phone2.png) center center no-repeat;
      background-size: 60% 60%;
      z-index: 1000;
      p {
        display: none;
      }
      h3 {
        display: none;
      }
    }
  }
}
</style>
